import PropTypes from 'prop-types';
import React from 'react';

import { signup } from '../../client/action/navigateAuthentication';
import { QUANTUM_UI } from '../../flags';
import { useTranslation } from './hooks/useTranslation';

const buttonStyle = QUANTUM_UI ? 'btn-success-quantum-theme' : 'btn-success';

const TryBanner = (props, context) => {
  const { t } = useTranslation('core');

  return (
    <div id="try-banner" data-search-index="false">
      <div className="try-banner try-banner-alt">
        <span>{t('tryBanner.useAuth0ForFree', 'Use Auth0 for FREE')}</span>
        <button onClick={() => context.executeAction(signup)} className={`${buttonStyle} btn btn-lg`}>
          {t('tryBanner.createFreeAccount', 'Create free Account')}
        </button>
      </div>
    </div>
  );
};

TryBanner.contextTypes = {
  executeAction: PropTypes.func.isRequired,
};

export default TryBanner;
